<script lang="ts">
  const { size = 24, selected = false }: { size?: string | number; selected?: boolean } = $props();
</script>


<svg
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="3"
    y="4"
    width="18"
    height="18"
    rx="2"
    ry="2"
    class='bg'
    class:selected
    />
  <line
    x1="16"
    y1="2"
    x2="16"
    y2="6"
    />
  <line
    x1="8"
    y1="2"
    x2="8"
    y2="6"
  />
  <path
    class='letter'
    class:selected
    stroke="none"
    fill="currentColor"
    d="M 7.9960937,8.0253906 A 1.0234078,0.9695201 0 0 0 6.9726562,8.9960938 v 9.0078122 a 1.0234078,0.9695201 0 0 0 1.0234375,0.970703 h 2.9609383 c 1.159513,0 2.21894,-0.199543 3.140624,-0.630859 a 1.0234078,0.9695201 0 0 0 0.0039,-0.0019 c 0.925821,-0.438537 1.679241,-1.103432 2.177734,-1.939453 0.506975,-0.843881 0.748046,-1.82564 0.748046,-2.882813 0,-1.055696 -0.24057,-2.033869 -0.746093,-2.876954 C 15.78528,9.8001586 15.032539,9.1294314 14.107422,8.6894531 13.184255,8.2379684 12.11955,8.0253906 10.957032,8.0253906 Z M 10,11 h 0.806641 c 1.197056,0 1.902242,0.233844 2.390624,0.632812 a 1.186039,0.9423563 0 0 0 0.0078,0.0039 c 0.511763,0.412304 0.794922,0.973908 0.794922,1.888671 0,0.906666 -0.282344,1.45876 -0.78125,1.861328 -0.4826,0.38148 -1.200578,0.613282 -2.412109,0.613282 H 10 Z" />
</svg>

<style lang='scss'>
  @use 'sass:color';
  @use '~/theme/theme.scss';
  .letter.selected {
    fill: theme.$star-bonus;
  }
  .bg.selected {
    fill: currentColor;
  }
</style>